<template>
  <div class="new-layout">
    <div class="new-layout-bg">
      <div class="new-content">
        <div class="title">大凉山的希望火种 ——直击塔哈村小学破茧之路</div>
        <div style="color: rgba(80, 80, 80, 0.7);margin-top: 6px;text-align: center" >2025年05月15日 15:10 贵州</div>
        <div class="content">
          <video class="video-sty" controls>
            <source src="https://skyline-project-web.oss-cn-hangzhou.aliyuncs.com/video/2.mp4"  type="video/mp4">
          </video>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };

  },

  methods: {


    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
    position: relative;

  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 12px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-direction:column;



    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
      .video-sty{
        width: 70%;
      }
      .ds-ct{
        text-align: justify;
      }


      .new-icon {
        text-align: justify;
        width: 80%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      text-align: center;
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
    }

  }


}
</style>
